import React, { useState, useCallback } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MapComponent from './components/MapComponent';
import LayerControl from './components/LayerControl';
import UserMenu from './components/UserMenu';
import AddDoctorDialog from './components/AddDoctorDialog';
import './App.css';

function AppContent() {
  const [activeLayers, setActiveLayers] = useState({});
  const [isAddDoctorOpen, setIsAddDoctorOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const toggleLayer = (layerName) => {
    setActiveLayers(prev => ({
      ...prev,
      [layerName]: !prev[layerName]
    }));
  };

  const handleDoctorAdded = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  return (
    <div className="app">
      <UserMenu />
      <LayerControl 
        activeLayers={activeLayers}
        toggleLayer={toggleLayer}
      />
      <button 
        className="add-doctor-button"
        onClick={() => setIsAddDoctorOpen(true)}
        title="Neuen Arzt hinzufügen"
      >
        +
      </button>
      <MapComponent activeLayers={activeLayers} key={refreshKey} />
      <AddDoctorDialog 
        isOpen={isAddDoctorOpen}
        onClose={() => setIsAddDoctorOpen(false)}
        onDoctorAdded={handleDoctorAdded}
      />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <AppContent />
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
